import React from 'react'
import styled from 'styled-components'
import Plaatjie from '@ubo/plaatjie'

// Components
import ParseContent from 'components/shared/ParseContent'

// Interface
import { BannerProps } from 'components/flex/Banner/Shell'

const Image = styled(Plaatjie)``

const Content = styled(ParseContent)`
  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    @media (min-width: 992px) {
      font-size: 50px;
    }
  }
`

const BannerDefault: React.FC<BannerProps> = ({ fields }) => (
  <section className="mb-5">
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="row">
            <div className="col-md-5 d-flex flex-column align-items-center">
              <Image image={fields.icon} className="mb-5" alt="" />
              <ParseContent content={fields.cta} />
            </div>
            <div className="col-md-7 mt-5 mt-md-0">
              <Content content={fields.description} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default BannerDefault
